<template>
    <div class="home-header">
        <div class="header">
            <el-image class="logo"
                      @click="logoClick"
                      @error="logoError"
                      :src="websiteData.logo"></el-image>
            <div class="menu  hidden-sm-and-down">
                <el-menu style="flex-shrink: 0;" v-if="hxClassifyList" :default-active="indexModal" mode="horizontal">
                    <el-menu-item @click="menuClick" :index="index + ''" style="margin: 0 20px"
                                  v-for="(item,index) in hxClassifyList.slice(0,5)" :key="index">
                        <span slot="title">{{item.title}}</span>
                    </el-menu-item>
                </el-menu>
                <el-button @click="login" style="margin: 0 20px;" type="text">
                    企业oa登录
                </el-button>
            </div>

            <div v-show="menuShow" class="hidden-sm-and-up">
                <i @click="open" class="icon"
                   :class="value ? 'animate__animated animate__tada el-icon-s-fold' : 'el-icon-s-unfold'"></i>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "header-index",
        props: {
            value: Boolean,
            menuShow: Boolean,
            index: String,
            hxClassifyList: Array,
            websiteData: Object
        },
        data() {
            return {
                activeIndex: null,
            };
        },
        computed: {
            indexModal: {
                get() {
                    return this.index;
                },
                set(val) {
                    this.$emit('update:index', val);
                }
            }
        },
        methods: {
            // logo点击
            logoClick() {
                if(this.$route.path === '/index'){
                    return
                }

                this.$router.push({
                    path: "/index",
                })
            },
            // logo加载失败
            logoError() {
                this.$emit('logoError')
            },
            login() {
                window.open("http://oa.gdhxtech.cn/login?redirect=%2Findex")
                // window.open("http://localhost/login?redirect=%2Findex")
            },
            open() {
                this.$emit('update:value', !this.value)
            },
            menuClick(e){
                let menu
                if(e.index === '0'){
                    menu = document.getElementById("menu0")
                }else if(e.index === '1'){
                    menu = document.getElementById("menu1")
                }else if(e.index === '2'){
                    menu = document.getElementById("menu2")
                }else if(e.index === '3'){
                    menu = document.getElementById("menu3")
                }else if(e.index === '4'){
                    menu = document.getElementById("menu4")
                }

                window.scrollTo({
                    top: menu.offsetTop - 100,
                    behavior: "smooth"
                });
            },
        }
    }
</script>

<style lang="scss" scoped>

    .logo {
        width: 60px;
        transition: 0.5s;
        height: 60px;

        &:hover {
            transform: scale(1.1);
            cursor: pointer;
        }
    }

    .home-header {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        position: fixed;
        background: #fff;
        z-index: 9;
        top: 0;
        height: 80px;
        padding: 0 20px;
        box-shadow: 0 2px 5px 0 rgba(0,0,0,0.16), 0 2px 10px 0 rgba(0,0,0,0.12);
    }

    .header {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .menu {
            display: flex;
            align-items: center;

        }

        .hidden-sm-and-up {
            margin-right: 40px;

            .icon {
                font-size: 26px;
                cursor: pointer;
                transition: 0.5s;

                &:hover {
                    transform: scale(1.1);
                }
            }
        }
    }

    @media screen and (min-width: 1200px) {
        .header{
            width: 70%;
        }
    }

    @media screen and (max-width: 1200px) {
        .header{
            width: 70%;
        }
    }

    @media screen and (max-width: 870px) {
        .header{
            width: 100%;
        }
    }

    @media screen and (max-width: 570px) {
        .logo {
            width: 60px;
        }

        .header{
            width: 100%;
        }
    }
</style>
